import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {EventRegistrationRoutingModule} from './event-registration-routing.module';
import {EventRegistrationComponent} from './event-registration.component';
import {EventRegistrationRepository} from './repositories/event-registration.repository';
import {EventRegistrationService} from './services/event-registration.service';
import { PasswordStrengthBarModule } from '../password-strength-bar/password-strenght-bar.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PasswordStrengthBarModule,
    EventRegistrationRoutingModule,
  ],
  declarations: [
    EventRegistrationComponent,
  ],
  providers: [
    EventRegistrationService,
    {
      provide: 'IEventRegistrationRepository',
      useClass: EventRegistrationRepository,
    },
  ],
  exports: [
    EventRegistrationComponent,
  ],
})

export class EventRegistrationModule { }
